import { useEffect, useRef } from "react";

export default function usePoll(callback, delay, enabled = true) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback, enabled]);

  useEffect(() => {
    let id;

    function tick() {
      const returnValue = savedCallback.current();

      if (returnValue instanceof Promise) {
        returnValue
          .then(() => {
            if (delay) {
              id = setTimeout(tick, delay);
            }
          })
          .catch(() => {
            if (delay) {
              id = setTimeout(tick, delay);
            }
          });
      } else if (delay) {
        id = setTimeout(tick, delay);
      }
    }

    if (delay && enabled) {
      savedCallback.current();
      id = setTimeout(tick, delay);
      return () => id && clearTimeout(id);
    } else if (enabled) {
      savedCallback.current();
    }
  }, [delay, enabled]);
}
